import { toast } from 'sonner';

import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class EventObservabilityIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchSummary() {
        try {
            return await this.service.getSummary();
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async fetchRecentActivity(params = {}) {
        try {
            return await this.service.getRecentActivity(params);
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async fetchTopEvents(params = {}) {
        try {
            return await this.service.getTopEvents(params);
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async fetchWorkerHealth() {
        try {
            return await this.service.getWorkerHealth();
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }
}
